const galleryId = 1;

const items = [];

let id = galleryId * 1000;
function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}

let group = [];

group = ["sh_1277759158.jpg","sh_1408362395.jpg","sh_1627811641.jpg","sh_1218120193.jpg"];
group.forEach((i) => addItemToGroup(i, '1. All-on-4™'));

group = ["sh_1311646634.jpg","sh_1377554249.jpg","sh_1505970470.jpg","sh_1669842505.jpg","sh_537170143.jpg"];
group.forEach((i) => addItemToGroup(i, '2. All-on-6™'));

group = ["sh_1165261312.jpg"];
group.forEach((i) => addItemToGroup(i, 'Before-after'));

group = ["sh_93396676.jpg","sh_70384249.jpg"];
group.forEach((i) => addItemToGroup(i, 'deleted'));

export default items;
